import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import { ResponsiveSourceDocumentLink } from '@ctw/shared/content/CCDA/responsive-source-document-link';
import {
  DiagnosticReportObservationList,
  diagnosticReportData,
} from '@ctw/shared/content/diagnostic-reports/helpers/observation-list';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { tw } from '@ctw/shared/utils/tailwind';

export const diagnosticReportDrawerAction: UseResourceDrawerOpenDrawerArgs<'DiagnosticReport'>['action'] =
  ({ model }) => ({
    label: 'Diagnostic Report',
    title: model.displayName,
    content: {
      body: (
        <div className={tw`flex flex-col gap-5`}>
          <ContentCard
            variant="focal"
            title="Details"
            content={{
              header: <ResponsiveSourceDocumentLink model={model} />,
            }}
          >
            <DefinitionList items={diagnosticReportData(model)} />
          </ContentCard>
          <DiagnosticReportObservationList model={model} />
        </div>
      ),
    },
  });
